export default __webpack_public_path__ + "201fec521c194633c62aa0c208f9af4b.png";